import { Page } from "@boundary/layouts/pageLayout";
import { DomainScreenBackground } from "@boundary/components/domainScreenBackground";
import { LinkDomainScreenBackground } from "@boundary/components/linkDomainScreenBackground";
import { MainScreenBackground } from "@boundary/components/mainScreenBackground";
import { PaymentDomainScreenBackground } from "@boundary/components/paymentDomainScreenBackground";
import { PrintDomainScreenBackground } from "@boundary/components/printDomainScreenBackground";
import { ReferralDomainScreenBackground } from "@boundary/components/referralDomainScreenBackground";
import { SubScreenBackground } from "@boundary/components/subScreenBackground";
import {
  screenBackgroundGalleryItems,
  type ScreenBackgroundGalleryKey
} from "@shared/configs/screenBackgroundGallery";
import styles from "./screenBackgroundsGallery.module.scss";

function GalleryBackgroundPreview({ variant }: { variant: ScreenBackgroundGalleryKey }) {
  switch (variant) {
    case "hub":
      return <MainScreenBackground />;
    case "oauth":
      return <DomainScreenBackground />;
    case "print":
      return <PrintDomainScreenBackground />;
    case "payment":
      return <PaymentDomainScreenBackground />;
    case "link":
      return <LinkDomainScreenBackground />;
    case "referral":
      return <ReferralDomainScreenBackground />;
    case "sub":
      return <SubScreenBackground />;
    default: {
      const _exhaustive: never = variant;
      return _exhaustive;
    }
  }
}

export function ScreenBackgroundsGalleryPage() {
  return (
    <Page screenBackground="none">
      <Page.SafeArea />
      <Page.DisplayZone>
        <Page.DisplayZone.Header back center={<h1>Фоны сервисов</h1>} />
        <Page.DisplayZone.Body className={styles.body}>
          <p className={styles.lead}>
            Превью для согласования палитры мега-приложения: каждый блок — тот же компонент фона, что на экранах.
            Для Figma зафиксируйте CSS из соответствующих *.module.scss или переменные (--mainScreenBackground и т.д.).
          </p>
          {screenBackgroundGalleryItems.map((item) => (
            <section key={item.key} className={styles.tile} aria-label={item.title}>
              <div className={styles.tileCanvas}>
                <GalleryBackgroundPreview variant={item.key} />
              </div>
              <h2 className={styles.tileTitle}>{item.title}</h2>
              <p className={styles.tileHint}>{item.description}</p>
            </section>
          ))}
        </Page.DisplayZone.Body>
      </Page.DisplayZone>
    </Page>
  );
}
